import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex gap-4 h-full"
};
const _hoisted_2 = {
  class: "w-40 shrink-0 bg-slate-50 rounded-xl p-3 border border-slate-200 overflow-y-auto"
};
const _hoisted_3 = {
  class: "space-y-1.5"
};
const _hoisted_4 = ["onDragstart"];
const _hoisted_5 = {
  class: "flex-1 bg-slate-50 rounded-xl p-3 border border-slate-200 overflow-y-auto"
};
const _hoisted_6 = {
  key: 0,
  class: "h-full flex items-center justify-center text-slate-400 text-xs"
};
const _hoisted_7 = {
  key: 1,
  class: "space-y-2"
};
const _hoisted_8 = {
  class: "flex items-center gap-3"
};
const _hoisted_9 = {
  class: "text-slate-400"
};
const _hoisted_10 = ["onUpdate:modelValue", "onInput"];
const _hoisted_11 = ["onUpdate:modelValue"];
const _hoisted_12 = ["value"];
const _hoisted_13 = {
  class: "flex items-center gap-1 cursor-pointer"
};
const _hoisted_14 = ["onUpdate:modelValue"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 0,
  class: "mt-2 ml-7"
};
const _hoisted_17 = ["onUpdate:modelValue"];
const _hoisted_18 = {
  key: 1,
  class: "mt-2 ml-7"
};
const _hoisted_19 = ["onUpdate:modelValue"];
const _hoisted_20 = {
  class: "w-64 shrink-0 bg-slate-50 rounded-xl p-3 border border-slate-200 overflow-y-auto"
};
const _hoisted_21 = {
  class: "text-xs text-slate-600 bg-white rounded p-2 overflow-auto max-h-[400px] font-mono"
};
import { ref, reactive, computed, watch, h } from 'vue';
import { ElMessage } from 'element-plus';
export default {
  __name: 'FormBuilder',
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        type: 'object',
        properties: {},
        required: []
      })
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isDragOver = ref(false);
    const draggingType = ref(null);

    // 字段类型定义
    const fieldTypes = [{
      type: 'text',
      label: '文本'
    }, {
      type: 'number',
      label: '数字'
    }, {
      type: 'date',
      label: '日期'
    }, {
      type: 'select',
      label: '下拉'
    }, {
      type: 'textarea',
      label: '多行'
    }, {
      type: 'email',
      label: '邮箱'
    }, {
      type: 'phone',
      label: '手机'
    }];

    // 字段列表
    const fields = reactive([]);

    // 初始化字段
    function initFields() {
      fields.length = 0;
      if (props.modelValue?.properties) {
        Object.entries(props.modelValue.properties).forEach(([name, config]) => {
          fields.push({
            name,
            title: config.title || name,
            type: config.type || 'text',
            format: config.format || '',
            enumValues: config.enumValues ? config.enumValues.join(',') : '',
            required: props.modelValue.required?.includes(name) || false
          });
        });
      }
    }

    // 监听 modelValue 变化
    watch(() => props.modelValue, () => {
      initFields();
    }, {
      immediate: true,
      deep: true
    });

    // 获取字段图标
    function getFieldIcon(type) {
      const icons = {
        text: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M4 6h16M4 12h16M4 18h7'
        })]),
        number: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M7 20l4-16m2 16l4-16M6 9h14M4 15h14'
        })]),
        date: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
        })]),
        select: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M19 9l-7 7-7-7'
        })]),
        textarea: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M4 6h16M4 12h16M4 18h12'
        })]),
        email: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
        })]),
        phone: () => h('svg', {
          fill: 'none',
          stroke: 'currentColor',
          viewBox: '0 0 24 24'
        }, [h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
        })])
      };
      return icons[type] || icons.text;
    }

    // 拖拽处理
    function handleDragStart(event, type) {
      draggingType.value = type;
      event.dataTransfer.effectAllowed = 'copy';
    }
    function handleDragOver(event) {
      event.dataTransfer.dropEffect = 'copy';
      isDragOver.value = true;
    }
    function handleDragLeave() {
      isDragOver.value = false;
    }
    function handleDrop() {
      isDragOver.value = false;
      if (!draggingType.value) return;
      const type = draggingType.value;
      const existingNames = fields.map(f => f.name);

      // 生成唯一字段名
      let baseName = `${type}_field`;
      let name = baseName;
      let counter = 1;
      while (existingNames.includes(name)) {
        name = `${baseName}_${counter++}`;
      }

      // 根据类型生成默认标题和格式
      const typeLabels = {
        text: '文本',
        number: '数字',
        date: '日期',
        select: '下拉选择',
        textarea: '多行文本',
        email: '邮箱',
        phone: '手机号'
      };
      const defaultTitle = typeLabels[type] || '字段';

      // date类型默认格式为date
      const defaultFormat = type === 'date' ? 'date' : '';
      fields.push({
        name,
        title: defaultTitle,
        type,
        format: defaultFormat,
        enumValues: '',
        required: false
      });
      draggingType.value = null;
      updateModelValue();
    }

    // 标题变化时自动生成字段名
    function onTitleChange(field) {
      if (!field.title || !field.title.trim()) {
        // 标题为空时，不修改字段名，保持原值
        return;
      }
      // 将标题转为合法的字段名：去除空格、特殊字符，转为下划线分隔
      field.name = field.title.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_\u4e00-\u9fa5]/g, '').toLowerCase();
    }
    function removeField(index) {
      fields.splice(index, 1);
      updateModelValue();
    }
    function updateModelValue() {
      const properties = {};
      const required = [];
      fields.forEach(field => {
        const fieldConfig = {
          type: field.type,
          title: field.title
        };
        if (field.type === 'select' && field.enumValues) {
          fieldConfig.enumValues = field.enumValues.split(',').map(v => v.trim()).filter(Boolean);
        }
        if (field.type === 'date') {
          fieldConfig.format = field.format || 'date';
        }
        properties[field.name] = fieldConfig;
        if (field.required) {
          required.push(field.name);
        }
      });
      emit('update:modelValue', {
        type: 'object',
        properties,
        required: required.length > 0 ? required : undefined
      });
    }
    const schemaJson = computed(() => JSON.stringify(props.modelValue, null, 2));
    function copySchema() {
      navigator.clipboard.writeText(schemaJson.value).then(() => {
        ElMessage.success('已复制');
      }).catch(() => {
        ElMessage.error('复制失败');
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("h4", {
        class: "text-xs font-semibold text-slate-500 uppercase mb-3"
      }, "拖拽添加", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(fieldTypes, field => {
        return _createElementVNode("div", {
          key: field.type,
          draggable: "true",
          onDragstart: $event => handleDragStart($event, field.type),
          class: "px-3 py-2 bg-white rounded-lg border border-slate-200 text-xs text-slate-600 cursor-move hover:border-primary-400 hover:bg-primary-50 transition-colors flex items-center gap-2"
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(field.icon), {
          class: "w-4 h-4 text-slate-400"
        })), _createTextVNode(" " + _toDisplayString(field.label), 1)], 40, _hoisted_4);
      }), 64))])]), _createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "flex items-center justify-between mb-3"
      }, [_createElementVNode("h4", {
        class: "text-xs font-semibold text-slate-500 uppercase"
      }, "字段列表"), _createElementVNode("span", {
        class: "text-xs text-slate-400"
      }, "拖放到此处")], -1)), _createElementVNode("div", {
        onDragover: _withModifiers(handleDragOver, ["prevent"]),
        onDrop: handleDrop,
        onDragleave: handleDragLeave,
        class: _normalizeClass(["min-h-[300px] bg-white rounded-lg border-2 border-dashed transition-colors p-3", isDragOver.value ? 'border-primary-400 bg-primary-50' : 'border-slate-200'])
      }, [fields.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 拖拽左侧字段类型添加 ")) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: field.name,
          class: "bg-white rounded-lg border border-slate-200 p-3 hover:border-primary-300 transition-colors"
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createBlock(_resolveDynamicComponent(getFieldIcon(field.type)), {
          class: "w-4 h-4"
        }))]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => field.title = $event,
          type: "text",
          class: "flex-1 px-2 py-1 border border-slate-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-primary-500",
          placeholder: "请输入字段标题",
          onInput: $event => onTitleChange(field),
          onChange: updateModelValue
        }, null, 40, _hoisted_10), [[_vModelText, field.title]]), _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": $event => field.type = $event,
          class: "w-20 px-2 py-1 border border-slate-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-primary-500",
          onChange: updateModelValue
        }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(fieldTypes, ft => {
          return _createElementVNode("option", {
            key: ft.type,
            value: ft.type
          }, _toDisplayString(ft.label), 9, _hoisted_12);
        }), 64))], 40, _hoisted_11), [[_vModelSelect, field.type]]), _createElementVNode("label", _hoisted_13, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => field.required = $event,
          type: "checkbox",
          class: "w-3 h-3 text-primary-600 border-slate-300 rounded",
          onChange: updateModelValue
        }, null, 40, _hoisted_14), [[_vModelCheckbox, field.required]]), _cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "text-xs text-slate-500"
        }, "必填", -1))]), _createElementVNode("button", {
          onClick: $event => removeField(index),
          class: "p-1 text-slate-400 hover:text-red-500 transition-colors cursor-pointer"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))], 8, _hoisted_15)]), field.type === 'select' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => field.enumValues = $event,
          type: "text",
          class: "w-full px-2 py-1 border border-slate-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-primary-500",
          placeholder: "枚举值：选项1,选项2,选项3",
          onChange: updateModelValue
        }, null, 40, _hoisted_17), [[_vModelText, field.enumValues]])])) : _createCommentVNode("", true), field.type === 'date' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": $event => field.format = $event,
          class: "px-2 py-1 border border-slate-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-primary-500",
          onChange: updateModelValue
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("option", {
          value: "date"
        }, "日期", -1), _createElementVNode("option", {
          value: "datetime"
        }, "日期时间", -1), _createElementVNode("option", {
          value: "time"
        }, "时间", -1)]))], 40, _hoisted_19), [[_vModelSelect, field.format]])])) : _createCommentVNode("", true)]);
      }), 128))]))], 34)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
        class: "flex items-center justify-between mb-3"
      }, [_cache[5] || (_cache[5] = _createElementVNode("h4", {
        class: "text-xs font-semibold text-slate-500 uppercase"
      }, "Schema", -1)), _createElementVNode("button", {
        onClick: copySchema,
        class: "px-2 py-1 text-xs text-primary-600 hover:bg-primary-50 rounded transition-colors cursor-pointer"
      }, " 复制 ")]), _createElementVNode("pre", _hoisted_21, _toDisplayString(schemaJson.value), 1)])]);
    };
  }
};